/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {fetchData, getEncryptedRoute, toasterrormsg, useMenuIdPermissions} from '../../../reusable'
import {Tr} from '../../../_metronic/i18n/Tr'

interface AddRestaurantHeaderProps {
  restaurantId: string // Assuming restaurantId is of type string, adjust as needed
}
const AddRestaurantHeader: React.FC<AddRestaurantHeaderProps> = ({restaurantId}) => {
  let t = Tr()
  const {menuId} = useMenuIdPermissions()

  var vendorId = ''
  const vendorData = sessionStorage.getItem('vendor')
  if (vendorData) {
    var vendor = JSON.parse(vendorData)
    vendorId = vendor.vendorId
  } else {
  }
  const location = useLocation()
  const editRestaurantId = (location.state as any)?.restaurantId || ''

  const [restaurantDetails, setRestaurantDetails] = useState([])

  // restaurant Details api call
  const restaurantDetailsApiCall = async () => {
    var param: any = {
      restaurantId: editRestaurantId,
    }
    var response: any = await fetchData('vendor/public/restaurantDetail', param)

    if (response.status == '200') {
      var restaurantData = response.data
      setRestaurantDetails(restaurantData)
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (editRestaurantId != '') {
      restaurantDetailsApiCall()
    }
  }, [])

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body'>
          <div className='d-flex overflow-auto'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder my-2 flex-nowrap'>
              <li className='nav-item'>
                {restaurantDetails &&
                restaurantDetails.length > 0 &&
                restaurantDetails[0]['completedSteps'] &&
                restaurantDetails[0]['completedSteps']['basicInfo'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      restaurantDetails &&
                      restaurantDetails.length > 0 &&
                      restaurantDetails[0]['completedSteps'] &&
                      restaurantDetails[0]['completedSteps']['basicInfo']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addrestaurantbasicinfo/'
                        ? `${
                            restaurantDetails &&
                            restaurantDetails.length > 0 &&
                            restaurantDetails[0]['completedSteps'] &&
                            restaurantDetails[0]['completedSteps']['basicInfo']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addrestaurantbasicinfo/', {menuId:menuId})}
                    state={{restaurantId: editRestaurantId}}
                  >
                    {t('Basic Info')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      restaurantDetails &&
                      restaurantDetails.length > 0 &&
                      restaurantDetails[0]['completedSteps'] &&
                      restaurantDetails[0]['completedSteps']['basicInfo']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addrestaurantbasicinfo/'
                        ? `${
                            restaurantDetails &&
                            restaurantDetails.length > 0 &&
                            restaurantDetails[0]['completedSteps'] &&
                            restaurantDetails[0]['completedSteps']['basicInfo']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Basic Info')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {restaurantDetails &&
                restaurantDetails.length > 0 &&
                restaurantDetails[0]['completedSteps'] &&
                restaurantDetails[0]['completedSteps']['location'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      restaurantDetails &&
                      restaurantDetails.length > 0 &&
                      restaurantDetails[0]['completedSteps'] &&
                      restaurantDetails[0]['completedSteps']['location']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addrestaurantlocation/'
                        ? `${
                            restaurantDetails &&
                            restaurantDetails.length > 0 &&
                            restaurantDetails[0]['completedSteps'] &&
                            restaurantDetails[0]['completedSteps']['location']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addrestaurantlocation/', {menuId:menuId})}
                    state={{restaurantId: editRestaurantId}}
                  >
                    {t('Location')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      restaurantDetails &&
                      restaurantDetails.length > 0 &&
                      restaurantDetails[0]['completedSteps'] &&
                      restaurantDetails[0]['completedSteps']['location']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addrestaurantlocation/'
                        ? `${
                            restaurantDetails &&
                            restaurantDetails.length > 0 &&
                            restaurantDetails[0]['completedSteps'] &&
                            restaurantDetails[0]['completedSteps']['location']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Location')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {restaurantDetails &&
                restaurantDetails.length > 0 &&
                restaurantDetails[0]['completedSteps'] &&
                restaurantDetails[0]['completedSteps']['propertyDetail'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      restaurantDetails &&
                      restaurantDetails.length > 0 &&
                      restaurantDetails[0]['completedSteps'] &&
                      restaurantDetails[0]['completedSteps']['propertyDetail']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addrestaurantdetails/'
                        ? `${
                            restaurantDetails &&
                            restaurantDetails.length > 0 &&
                            restaurantDetails[0]['completedSteps'] &&
                            restaurantDetails[0]['completedSteps']['propertyDetail']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addrestaurantdetails/', {menuId:menuId})}
                    state={{restaurantId: editRestaurantId}}
                  >
                    {t('Property Details')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      restaurantDetails &&
                      restaurantDetails.length > 0 &&
                      restaurantDetails[0]['completedSteps'] &&
                      restaurantDetails[0]['completedSteps']['propertyDetail']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addrestaurantdetails/'
                        ? `${
                            restaurantDetails &&
                            restaurantDetails.length > 0 &&
                            restaurantDetails[0]['completedSteps'] &&
                            restaurantDetails[0]['completedSteps']['propertyDetail']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Property Details')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {restaurantDetails &&
                restaurantDetails.length > 0 &&
                restaurantDetails[0]['completedSteps'] &&
                restaurantDetails[0]['completedSteps']['menu'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      restaurantDetails &&
                      restaurantDetails.length > 0 &&
                      restaurantDetails[0]['completedSteps'] &&
                      restaurantDetails[0]['completedSteps']['menu']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addrestaurantmenu/'
                        ? `${
                            restaurantDetails &&
                            restaurantDetails.length > 0 &&
                            restaurantDetails[0]['completedSteps'] &&
                            restaurantDetails[0]['completedSteps']['menu']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addrestaurantmenu/', {menuId:menuId})}
                    state={{restaurantId: editRestaurantId}}
                  >
                    {t('Menu')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      restaurantDetails &&
                      restaurantDetails.length > 0 &&
                      restaurantDetails[0]['completedSteps'] &&
                      restaurantDetails[0]['completedSteps']['menu']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addrestaurantmenu/'
                        ? `${
                            restaurantDetails &&
                            restaurantDetails.length > 0 &&
                            restaurantDetails[0]['completedSteps'] &&
                            restaurantDetails[0]['completedSteps']['menu']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Menu')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {restaurantDetails &&
                restaurantDetails.length > 0 &&
                restaurantDetails[0]['completedSteps'] &&
                restaurantDetails[0]['completedSteps']['photos'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      restaurantDetails &&
                      restaurantDetails.length > 0 &&
                      restaurantDetails[0]['completedSteps'] &&
                      restaurantDetails[0]['completedSteps']['photos']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addrestaurantphotos/'
                        ? `${
                            restaurantDetails &&
                            restaurantDetails.length > 0 &&
                            restaurantDetails[0]['completedSteps'] &&
                            restaurantDetails[0]['completedSteps']['photos']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addrestaurantphotos/', {menuId:menuId})}
                    state={{restaurantId: editRestaurantId}}
                  >
                    {t('Photos')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      restaurantDetails &&
                      restaurantDetails.length > 0 &&
                      restaurantDetails[0]['completedSteps'] &&
                      restaurantDetails[0]['completedSteps']['photos']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addrestaurantphotos/'
                        ? `${
                            restaurantDetails &&
                            restaurantDetails.length > 0 &&
                            restaurantDetails[0]['completedSteps'] &&
                            restaurantDetails[0]['completedSteps']['photos']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Photos')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {restaurantDetails &&
                restaurantDetails.length > 0 &&
                restaurantDetails[0]['completedSteps'] &&
                restaurantDetails[0]['completedSteps']['facilitiesAndServices'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      restaurantDetails &&
                      restaurantDetails.length > 0 &&
                      restaurantDetails[0]['completedSteps'] &&
                      restaurantDetails[0]['completedSteps']['facilitiesAndServices']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addrestaurantfacilities/'
                        ? `${
                            restaurantDetails &&
                            restaurantDetails.length > 0 &&
                            restaurantDetails[0]['completedSteps'] &&
                            restaurantDetails[0]['completedSteps']['facilitiesAndServices']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addrestaurantfacilities/', {menuId:menuId})}
                    state={{restaurantId: editRestaurantId}}
                  >
                    {t('Facilities & Services')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      restaurantDetails &&
                      restaurantDetails.length > 0 &&
                      restaurantDetails[0]['completedSteps'] &&
                      restaurantDetails[0]['completedSteps']['facilitiesAndServices']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addrestaurantfacilities/'
                        ? `${
                            restaurantDetails &&
                            restaurantDetails.length > 0 &&
                            restaurantDetails[0]['completedSteps'] &&
                            restaurantDetails[0]['completedSteps']['facilitiesAndServices']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Facilities & Services')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {restaurantDetails &&
                restaurantDetails.length > 0 &&
                restaurantDetails[0]['completedSteps'] &&
                restaurantDetails[0]['completedSteps']['availability'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      restaurantDetails &&
                      restaurantDetails.length > 0 &&
                      restaurantDetails[0]['completedSteps'] &&
                      restaurantDetails[0]['completedSteps']['availability']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addrestaurantavailability/'
                        ? `${
                            restaurantDetails &&
                            restaurantDetails.length > 0 &&
                            restaurantDetails[0]['completedSteps'] &&
                            restaurantDetails[0]['completedSteps']['availability']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addrestaurantavailability/', {menuId:menuId})}
                    state={{restaurantId: editRestaurantId}}
                  >
                    {t('Availability')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      restaurantDetails &&
                      restaurantDetails.length > 0 &&
                      restaurantDetails[0]['completedSteps'] &&
                      restaurantDetails[0]['completedSteps']['availability']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addrestaurantavailability/'
                        ? `${
                            restaurantDetails &&
                            restaurantDetails.length > 0 &&
                            restaurantDetails[0]['completedSteps'] &&
                            restaurantDetails[0]['completedSteps']['availability']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Availability')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {restaurantDetails &&
                restaurantDetails.length > 0 &&
                restaurantDetails[0]['completedSteps'] &&
                restaurantDetails[0]['completedSteps']['policies'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      restaurantDetails &&
                      restaurantDetails.length > 0 &&
                      restaurantDetails[0]['completedSteps'] &&
                      restaurantDetails[0]['completedSteps']['policies']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addrestaurantpolicies/'
                        ? `${
                            restaurantDetails &&
                            restaurantDetails.length > 0 &&
                            restaurantDetails[0]['completedSteps'] &&
                            restaurantDetails[0]['completedSteps']['policies']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addrestaurantpolicies/', {menuId:menuId})}
                    state={{restaurantId: editRestaurantId}}
                  >
                    {t('Policies')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      restaurantDetails &&
                      restaurantDetails.length > 0 &&
                      restaurantDetails[0]['completedSteps'] &&
                      restaurantDetails[0]['completedSteps']['policies']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addrestaurantpolicies/'
                        ? `${
                            restaurantDetails &&
                            restaurantDetails.length > 0 &&
                            restaurantDetails[0]['completedSteps'] &&
                            restaurantDetails[0]['completedSteps']['policies']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Policies')}
                  </button>
                )}
              </li>
              <li className='nav-item'>
                {restaurantDetails &&
                restaurantDetails.length > 0 &&
                restaurantDetails[0]['completedSteps'] &&
                restaurantDetails[0]['completedSteps']['financeAndLegal'] ? (
                  <Link
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      restaurantDetails &&
                      restaurantDetails.length > 0 &&
                      restaurantDetails[0]['completedSteps'] &&
                      restaurantDetails[0]['completedSteps']['financeAndLegal']
                        ? 'bg-primary text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addrestaurantfinance/'
                        ? `${
                            restaurantDetails &&
                            restaurantDetails.length > 0 &&
                            restaurantDetails[0]['completedSteps'] &&
                            restaurantDetails[0]['completedSteps']['financeAndLegal']
                              ? 'active_tab bg-success text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                    to={getEncryptedRoute('../addrestaurantfinance/', {menuId:menuId})}
                    state={{restaurantId: editRestaurantId}}
                  >
                    {t('Finance & Legal')}
                  </Link>
                ) : (
                  <button
                    className={`nav-link text-active-primary me-6 p-3 text-nowrap ${
                      restaurantDetails &&
                      restaurantDetails.length > 0 &&
                      restaurantDetails[0]['completedSteps'] &&
                      restaurantDetails[0]['completedSteps']['financeAndLegal']
                        ? 'bg-success text-white rounded'
                        : 'bg-transparent'
                    } ${
                      location.pathname === '/addrestaurantfinance/'
                        ? `${
                            restaurantDetails &&
                            restaurantDetails.length > 0 &&
                            restaurantDetails[0]['completedSteps'] &&
                            restaurantDetails[0]['completedSteps']['financeAndLegal']
                              ? 'active_tab text-white'
                              : 'active'
                          }`
                        : ''
                    }`}
                  >
                    {t('Finance & Legal')}
                  </button>
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export {AddRestaurantHeader}
